import { type FC } from "react";
import { Navigate, useParams } from "react-router-dom";

import { Tab, Tabs } from "@snapchat/snap-design-system";

import { AbsoluteRoute, type RouteParams } from "../../../core/routes";
import { PageContentSpinner } from "../../../layout/components";
import { useRemoteApiSpec } from "../../hooks";

import { ApiPageContainer, tabsStyle } from "./ApiPage.styles";
import { ActivityCard } from "./cards/activity-card";
import { ApiSettingsCard } from "./cards/api-settings-card/ApiSettingsCard";
import { ApiHeader } from "./header";
import { TabTitleAPIKeys, TabTitleAPISettings } from "./messages.generated";

export const ApiPage: FC = () => {
    const { apiId = "" } = useParams<RouteParams[AbsoluteRoute.API]>();
    const { spec, loading } = useRemoteApiSpec(apiId);

    if (loading) {
        return <PageContentSpinner />;
    }

    if (!spec) {
        return <Navigate to={AbsoluteRoute.APIS} />;
    }

    const { name, approvalState, version } = spec;

    return (
        <ApiPageContainer>
            <ApiHeader apiName={name} approvalState={approvalState} version={version} />
            <Tabs className={tabsStyle}>
                <Tab title={<TabTitleAPISettings />}>
                    <ApiSettingsCard spec={spec} />
                </Tab>
                <Tab title={<TabTitleAPIKeys />}>
                    <ActivityCard spec={spec} />
                </Tab>
            </Tabs>
        </ApiPageContainer>
    );
};
